import { Helper } from '../../Helper';
export class PickObjectPropertiesHelperBase extends Helper {
    emit(sb, node, options) {
        const objectValName = sb.scope.addUnique();
        const outputObjectValName = sb.scope.addUnique();
        sb.emitOp(node, 'SWAP');
        sb.scope.set(sb, node, options, objectValName);
        sb.emitOp(node, 'SWAP');
        sb.scope.set(sb, node, options, outputObjectValName);
        sb.emitHelper(node, options, sb.helpers.arrForEach({
            each: () => {
                sb.scope.get(sb, node, options, outputObjectValName);
                sb.emitOp(node, 'SWAP');
                sb.scope.get(sb, node, options, objectValName);
                sb.emitOp(node, 'OVER');
                sb.emitHelper(node, options, this.getObjectProperty(sb));
                sb.emitHelper(node, options, this.setObjectDataProperty(sb));
            },
        }));
    }
}

//# sourceMappingURL=PickObjectPropertiesHelperBase.js.map
